// 10 popular Arabic & Turkish movies/series for web stories.
// Posters & backdrops are loaded from TMDB at runtime using these IDs.
export type StoryEntry = {
  slug: string;
  tmdbId: number;
  tmdbType: "tv" | "movie";
  title: string;
  titleEn: string;
  year: number;
  rating: number;
  country: "TR" | "SY" | "LB" | "JO" | "SA" | "EG" | "QA" | string;
  genres: string[];
  overview: string;
  highlight: string; // tagline / hook for story page 2
  cast: string[];
  /** Optional manual poster URL (used by custom stories, skips TMDB). */
  posterUrl?: string;
  /** Optional manual backdrop URL (used by custom stories, skips TMDB). */
  backdropUrl?: string;
};

export const STORIES: StoryEntry[] = [
  {
    slug: "dirilis-ertugrul",
    tmdbId: 65494,
    tmdbType: "tv",
    title: "قيامة أرطغرل",
    titleEn: "Diriliş: Ertuğrul",
    year: 2014,
    rating: 8.0,
    country: "TR",
    genres: ["تاريخي", "دراما", "حربي"],
    overview:
      "ملحمة تاريخية تروي قصة أرطغرل بن سليمان شاه، والد عثمان مؤسس الدولة العثمانية، وكفاحه لحماية قبيلته وبناء أمة.",
    highlight: "ملحمة الفتوحات التي ألهمت ملايين المشاهدين حول العالم.",
    cast: ["Engin Altan Düzyatan", "Esra Bilgiç", "Cavit Çetin Güner"],
  },
  {
    slug: "kurulus-osman",
    tmdbId: 90387,
    tmdbType: "tv",
    title: "المؤسس عثمان",
    titleEn: "Kuruluş: Osman",
    year: 2019,
    rating: 7.8,
    country: "TR",
    genres: ["تاريخي", "دراما", "حربي"],
    overview:
      "تكملة لقصة أرطغرل، يروي المسلسل قصة ابنه عثمان غازي وتأسيسه للدولة العثمانية في مواجهة البيزنطيين والمغول.",
    highlight: "من قبيلة صغيرة إلى إمبراطورية امتدت لستة قرون.",
    cast: ["Burak Özçivit", "Özge Törer", "Yıldız Çağrı Atiksoy"],
  },
  {
    slug: "cukur",
    tmdbId: 74480,
    tmdbType: "tv",
    title: "الحفرة",
    titleEn: "Çukur",
    year: 2017,
    rating: 8.2,
    country: "TR",
    genres: ["جريمة", "إثارة", "دراما"],
    overview:
      "في حي إسطنبولي خطير يُعرف بـ«الحفرة»، تحكم عائلة كوتشوفالي شوارعه وتحمي سكانه من العصابات. يضطر الابن الأصغر يامَاج للعودة لإنقاذ إرث العائلة.",
    highlight: "حيث الشرف لا يُباع ولا يُشترى.",
    cast: ["Aras Bulut İynemli", "Dilan Çiçek Deniz", "Necip Memili"],
  },
  {
    slug: "kara-sevda",
    tmdbId: 66622,
    tmdbType: "tv",
    title: "حب أعمى",
    titleEn: "Kara Sevda",
    year: 2015,
    rating: 8.4,
    country: "TR",
    genres: ["رومانسي", "دراما"],
    overview:
      "قصة حب مستحيلة بين كمال الشاب الفقير الطموح ونيهان ابنة العائلة الثرية، يفرقهما القدر وتجمعهما المصادفات في صراع بين الحب والانتقام.",
    highlight: "أول مسلسل تركي يفوز بجائزة الإيمي الدولية.",
    cast: ["Burak Özçivit", "Neslihan Atagül", "Kaan Urgancıoğlu"],
  },
  {
    slug: "bir-zamanlar-cukurova",
    tmdbId: 79221,
    tmdbType: "tv",
    title: "نبضات قلب",
    titleEn: "Bir Zamanlar Çukurova",
    year: 2018,
    rating: 8.5,
    country: "TR",
    genres: ["دراما", "رومانسي", "تاريخي"],
    overview:
      "في خمسينيات القرن الماضي بسهل تشوكوروفا، يهرب عاشقان من إسطنبول ليجدا نفسيهما في قلب مؤامرات أسرة إقطاعية قاسية.",
    highlight: "حكاية ملحمية عن الحب والظلم والكرامة.",
    cast: ["Hilal Altınbilek", "Uğur Güneş", "Murat Ünalmış"],
  },
  {
    slug: "bab-al-hara",
    tmdbId: 32599,
    tmdbType: "tv",
    title: "باب الحارة",
    titleEn: "Bab Al-Hara",
    year: 2006,
    rating: 8.6,
    country: "SY",
    genres: ["دراما", "تاريخي", "اجتماعي"],
    overview:
      "حياة أهل حارة الضبع الدمشقية في زمن الانتداب الفرنسي، تتشابك فيها قصص الرجال والنساء بين الحب والعداوة ومقاومة المحتل.",
    highlight: "أيقونة الدراما الشامية التي جمعت العائلات العربية كل رمضان.",
    cast: ["عباس النوري", "بسام كوسا", "سامية الجزائري"],
  },
  {
    slug: "al-hayba",
    tmdbId: 73244,
    tmdbType: "tv",
    title: "الهيبة",
    titleEn: "Al Hayba",
    year: 2017,
    rating: 8.1,
    country: "LB",
    genres: ["دراما", "إثارة", "أكشن"],
    overview:
      "في قرية الهيبة على الحدود اللبنانية السورية، تعود أرملة الزعيم مع ابنها لتجد نفسها أمام تقاليد عشيرة الجبل وزعامة جبل شيخ الجبل.",
    highlight: "خمسة مواسم من الصراع، الحب، والسلطة.",
    cast: ["تيم حسن", "نادين نسيب نجيم", "عابد فهد"],
  },
  {
    slug: "omar",
    tmdbId: 41693,
    tmdbType: "tv",
    title: "عمر",
    titleEn: "Omar",
    year: 2012,
    rating: 9.2,
    country: "QA",
    genres: ["تاريخي", "ديني", "دراما"],
    overview:
      "مسلسل تاريخي ضخم يروي سيرة الخليفة الراشدي عمر بن الخطاب رضي الله عنه منذ ما قبل الإسلام حتى استشهاده، بإنتاج عربي مشترك.",
    highlight: "أضخم إنتاج درامي عربي تاريخي.",
    cast: ["سامر إسماعيل", "غسان مسعود", "محمد العبادي"],
  },
  {
    slug: "capernaum",
    tmdbId: 490132,
    tmdbType: "movie",
    title: "كفرناحوم",
    titleEn: "Capernaum",
    year: 2018,
    rating: 8.4,
    country: "LB",
    genres: ["دراما"],
    overview:
      "طفل لبناني في الثانية عشرة يرفع دعوى قضائية ضد والديه لإنجابه في عالم لا يرحم. فيلم نادين لبكي الذي رُشّح للأوسكار وحصد جائزة لجنة التحكيم في كان.",
    highlight: "صرخة طفل هزّت العالم — مرشّح أوسكار 2019.",
    cast: ["Zain Al Rafeea", "Yordanos Shiferaw", "Boluwatife Treasure Bankole"],
  },
  {
    slug: "theeb",
    tmdbId: 304357,
    tmdbType: "movie",
    title: "ذيب",
    titleEn: "Theeb",
    year: 2014,
    rating: 7.4,
    country: "JO",
    genres: ["مغامرة", "دراما", "إثارة"],
    overview:
      "في صحراء الحجاز إبّان الحرب العالمية الأولى، يرافق صبيٌّ بدوي أخاه الأكبر في رحلة خطرة لمساعدة ضابط بريطاني. فيلم أردني مرشّح للأوسكار.",
    highlight: "أول فيلم أردني يُرشَّح لجائزة الأوسكار.",
    cast: ["Jacir Eid Al-Hwietat", "Hussein Salameh Al-Sweilhiyeen", "Hassan Mutlag"],
  },
];

export const getStoryBySlug = (slug: string): StoryEntry | undefined => {
  // Browser: consult custom store first (admin-added stories override built-ins).
  if (typeof window !== "undefined") {
    try {
      const raw = window.localStorage.getItem("rawan-stories-v1");
      if (raw) {
        const arr = JSON.parse(raw) as StoryEntry[];
        const found = arr.find((s) => s.slug === slug);
        if (found) return found;
      }
    } catch { /* ignore */ }
  }
  return STORIES.find((s) => s.slug === slug);
};
